// extracted by mini-css-extract-plugin
export default {"editable-input__header":"EditableInput_editable-input__header__DlpXD","editable-input":"EditableInput_editable-input__PqXCt","input":"EditableInput_input__HWJ8t"};